<div class="d-flex h-100 w-100 px-3">
  <div class="card-credit-resume d-flex flex-column w-100 mb-3">
    <div class="d-flex encabezado">
      <div class="d-md-none p-3 icon" [style]="{'background': result.semaforo.TBC_COLOR}"
        [innerHtml]="result.semaforo.ICON | safeHtml"></div>
      <div class="text-center w-50 p-2 fecha">
        <p class="title">Fecha</p>
        <h5 class="fw-semibold">
          {{ result.fechaCreacion | date: "dd/MM/YYYY" }}
        </h5>
      </div>
      <div class="text-center w-50 p-2">
        <p class="title">Número de carpeta</p>
        <h5 class="fw-semibold">
          {{ result.numeroCarpeta }}
        </h5>
      </div>
    </div>
    <div class="d-none d-md-flex align-content-center p-3" [style]="{'background': result.semaforo.TBC_COLOR}">
      <div class="pe-3 align-content-center" [innerHtml]="result.semaforo.ICON | safeHtml"></div>
      <div class="flex-grow-1">
        <div style="color: #181D40; font-size: 11px;">
          Estado actual de la carpeta
        </div>
        <p class="estado fw-bold text-lowercase">{{ result.estado }}</p>
      </div>
    </div>
    <div class="info flex-grow-1" *ngIf="!isCollapsed" @growVertical>
      <div class="d-flex m-3">
        <div class="w-50">
          <p class="title">Pagaduria</p>
          <p class="text-lowercase">
            {{ result.pagaduria }}
          </p>
        </div>
        <div class="w-50">
          <p class="title">Monto</p>
          <p>
            ${{ result.montoSolicitado | number: "1.0-0"}} COP
          </p>
        </div>
      </div>
      <div class="d-flex m-3">
        <div class="w-50">
          <p class="title">Cuota</p>
          <p>
            ${{ result.valorCuota | number: "1.0-0"}} COP
          </p>
        </div>
        <div class="w-50">
          <p class="title">Tasa de interes (1)</p>
          <p>
            {{ result.tasaAprobada }}%
          </p>
        </div>
      </div>
      <div class="d-flex m-3">
        <div class="w-50">
          <p class="title">Plazo</p>
          <p>
            {{ result.plazoSolicitado }} meses
          </p>
        </div>
        <div class="w-50">
          <p class="title">Sucursal</p>
          <p class="text-lowercase">
            {{ result.nombreSucursal | sucursal }}
          </p>
        </div>
      </div>
      <div class="d-flex m-3">
        <div class="w-100">
          <p class="title">Seguro Aplicado (3)</p>
          <p class="text-lowercase">
            {{ result.planSeguroVoluntario | seguroVoluntario }}
          </p>
        </div>
      </div>
    </div>
    <div class="actions d-flex justify-content-between px-3 py-2">
      <button-look-feel [block]="true" size="small" color="outline" (clicked)="detalleCarpeta()" [disabled]="isLoading">
        Ver Detalles
      </button-look-feel>
      <button-look-feel [block]="true" size="small" color="secondary" (clicked)="goStep()" [loading]="isLoading">
        Retomar carpeta
      </button-look-feel>
    </div>
  </div>
  <div class="ms-3 mt-3 d-md-none" (click)="toggleInfo()">
    <i class="fa fa-arrow-right icono" [ngClass]="isCollapsed?'girarIcono':''"></i>
  </div>
</div>